/* Ridgebrace koopblok: keuzeblok + maat -> variant, toevoegen via /cart/add.js, dan naar de winkelwagen. */
(() => {
  const forms = document.querySelectorAll('[data-rb-buy]');
  forms.forEach((form) => {
    const status = form.querySelector('[data-rb-status]');
    const button = form.querySelector('[data-rb-submit]');
    const label = button ? button.textContent : '';
    const dataEl = form.querySelector('[data-rb-variants]');
    const data = dataEl ? JSON.parse(dataEl.textContent) : null;
    const idInput = form.querySelector('[data-rb-variant]');
    const qtyInput = form.querySelector('[data-rb-qty]');

    const say = (text, error) => {
      status.textContent = text;
      status.classList.toggle('rb-status--error', Boolean(error));
    };

    const current = () => {
      const pack = form.querySelector('input[name^="rb-pack-"]:checked');
      const size = form.querySelector('input[name^="rb-size-"]:checked');
      return { pack, size };
    };

    const resolve = () => {
      const { pack, size } = current();
      if (!data) return null;
      const match = data.variants.find((v) => {
        if (data.sizeIndex && size && v.options[data.sizeIndex - 1] !== size.value) return false;
        if (data.packIndex && pack && v.options[data.packIndex - 1] !== pack.value) return false;
        return true;
      });
      return match || null;
    };

    form.addEventListener('change', () => say(''));

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const { pack, size } = current();
      if (!size) { say('Choose your size first.', true); form.querySelector('input[name^="rb-size-"]').focus(); return; }
      if (form.hasAttribute('data-rb-concept')) { say('Concept: no product linked yet.', true); return; }
      const variant = resolve();
      if (!variant || !variant.available) { say('This size is sold out right now.', true); return; }
      idInput.value = variant.id;
      qtyInput.value = data.packIndex ? 1 : Number(pack ? pack.dataset.qty : 1) || 1;

      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding…';
      try {
        const res = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Number(qtyInput.value) }] }),
        });
        if (!res.ok) throw new Error(String(res.status));
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      } catch (e) {
        say('Something went wrong. Please try again.', true);
        button.removeAttribute('aria-busy');
        button.textContent = label;
      }
    });
  });
})();

/* Koopblok-galerij: duimnagel toont de bijbehorende grote foto. */
document.querySelectorAll('[data-rb-gallery]').forEach((g) => {
  const slides = g.querySelectorAll('[data-rb-slide]');
  const thumbs = g.querySelectorAll('[data-rb-thumb]');
  window.addEventListener('load', () => g.querySelectorAll('[data-rb-slide] img').forEach((img) => { img.loading = 'eager'; }));
  thumbs.forEach((t) => t.addEventListener('click', () => {
    const i = Number(t.dataset.rbThumb);
    slides.forEach((s, n) => { s.hidden = n !== i; });
    thumbs.forEach((x) => x.setAttribute('aria-current', String(x === t)));
  }));
});

/* Koopbalk onderin op mobiel: zichtbaar zolang de koopknop niet in beeld is (ook voor je erbij bent), weg als de knop in beeld is. */
document.querySelectorAll('[data-rb-stickybar]').forEach((bar) => {
  const sec = bar.closest('.rb-buy');
  const btn = sec && sec.querySelector('[data-rb-submit]');
  if (!btn || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver(([e]) => {
    bar.hidden = e.isIntersecting;
  });
  io.observe(btn);
});
